import * as firestore from 'firebase/firestore';
import { DateTime } from 'luxon';
import { MedicalPaperClinic, MedicalPaperRequest } from '../types/MedicalPaperRequest';

export default {
  toFirestore(medicalPaperRequest: MedicalPaperRequest): firestore.DocumentData {
    return medicalPaperRequest;
  },
  fromFirestore(
    snapshot: firestore.QueryDocumentSnapshot
  ): MedicalPaperRequest {
    const data = snapshot.data()!;
    return {
      id: data.id,
      idNumber: data.idNumber,
      name: data.name,
      clinic: data.clinic as MedicalPaperClinic,
      others: data.others,
      date: data.date,
      dateRequested: data.dateRequested,
      file: data.file,
      status: data.status,
      lastUpdate: typeof(data.lastUpdate) === 'string' ? data.lastUpdate : DateTime.fromJSDate((data.lastUpdate as firestore.Timestamp).toDate()).toISO()
    };
  }
};
